import { render, staticRenderFns } from "./TheTagList.vue?vue&type=template&id=39236129&scoped=true&"
import script from "./TheTagList.vue?vue&type=script&lang=js&"
export * from "./TheTagList.vue?vue&type=script&lang=js&"
import style0 from "./TheTagList.vue?vue&type=style&index=0&id=39236129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39236129",
  null
  
)

export default component.exports